export default __webpack_public_path__ + "static/media/digna-tutorial-2.e1761e0f.gif";